import { ForwardedRef, forwardRef, ReactNode } from 'react';
import {
  Error as ErrorIcon,
  Success as SuccessIcon,
  Warning as WarningIcon,
  Information as InformationIcon,
} from '@mos-cat/ds-icons';
import { pxToRem } from '@mos-cat/ds-theme';
import { useTheme } from '@emotion/react';
import { themeGet } from '@styled-system/theme-get';
import { Box, BoxOptions } from '../Box/Box';
import { WHCM } from '../constants';
import { Island } from '../Island/Island';

export type StatusIconType = 'success' | 'error' | 'warning' | 'info';

export type StatusIslandProps = {
  children: ReactNode;
  kind?: StatusIconType;
} & Omit<BoxOptions, 'paddingTop' | 'pt'>;

export const StatusIsland = forwardRef(
  (
    { children, kind = 'success', ...props }: StatusIslandProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const theme = useTheme();

    const Icon = {
      error: ErrorIcon,
      warning: WarningIcon,
      success: SuccessIcon,
      info: InformationIcon,
    };

    return (
      <Box
        {...props}
        width={1}
        maxWidth={pxToRem(736)}
        pt="sp-48"
        alignSelf="center"
        mx="auto"
        overflow="hidden"
      >
        <Island
          ref={ref}
          size="size-1"
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          pt={['sp-64', 'sp-72']}
          pb={['sp-48', 'sp-56']}
          px={['sp-16', 'sp-80']}
          styles={{
            textAlign: 'center',
          }}
        >
          <Box
            as={Icon[kind]}
            size={pxToRem(80)}
            maxWidth="90%"
            position="absolute"
            left="50%"
            top={pxToRem(-48)}
            backgroundColor="white"
            borderRadius="round"
            styles={{
              transform: 'translate(-50%, 0)',
              boxShadow: `0 0 0 ${pxToRem(12)} ${
                themeGet('colors.body')({ theme }) as string
              }`,
              label: 'StatusIcon',

              [WHCM]: {
                boxShadow: 'none',
                backgroundColor: 'Window',
              },
            }}
          />
          {children}
        </Island>
      </Box>
    );
  }
);
